import React, { useState, useRef, useEffect } from "react";
import { ActionType } from "../types";
import { ACTION_TYPE_OPTIONS } from "../constants";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { LanguageText } from "../../../../dictionary/GroupsText";
interface ActionFilterProps {
  value: ActionType | "";
  onChange: (value: ActionType | "") => void;
}

const ActionFilter: React.FC<ActionFilterProps> = ({ value, onChange }) => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (actionType: ActionType) => {
    onChange(actionType);
    setIsOpen(false);
  };

  const handleClear = () => {
    onChange("");
    setIsOpen(false);
  };

  const selectedOption = ACTION_TYPE_OPTIONS.find((option) => option.value === value);

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {Language?.groupAuditLogs?.action}
      </label>
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-left flex justify-between items-center"
        >
          <span className={selectedOption ? "text-gray-900" : "text-gray-500"}>
            {selectedOption
              ? selectedOption.label
              : Language?.groupAuditLogs?.filterByAction}
          </span>
          <svg
            className="h-5 w-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
          {ACTION_TYPE_OPTIONS.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              {option.label}
            </div>
          ))}
        </div>
      )}

      {value && (
        <div className="mt-2 flex items-center">
          <span className="text-sm text-gray-600">
            {Language?.groupAuditLogs?.selected}: {selectedOption?.label}
          </span>
          <button
            onClick={handleClear}
            className="ml-2 text-sm text-red-600 hover:text-red-800"
          >
            {Language?.groupAuditLogs?.clear}
          </button>
        </div>
      )}
    </div>
  );
};

export default ActionFilter;
